export const getChatMessageSpacing = (role: string, prevRole?: string) => ({
  "mt-2": prevRole !== undefined && prevRole === role,
  "mt-6": prevRole !== undefined && prevRole !== role,
});
